import {
  configurePropertyMap,
  getDefaultPropertyMapConfig,
} from 'modules/journey/components/FilterInputsList';
import { ESTypeMap } from 'modules/workflows';

export function filterMappingsByTriggeringEvent({
  mappings,
  dataType,
  eventName,
  nodeClass,
}: {
  mappings: ESTypeMap;
  dataType: string;
  eventName: string;
  nodeClass?: string;
}) {
  // for one, remove all non-eventName things from the mappings
  const filteredMappings = Object.keys(mappings).reduce((acc, key) => {
    if (key.startsWith(dataType)) {
      acc[key] = mappings[key];
    }
    return acc;
  }, {} as ESTypeMap);

  const config = getDefaultPropertyMapConfig({
    dataType: nodeClass || dataType,
    filterString: eventName,
  });

  const propertyMap = configurePropertyMap(filteredMappings[dataType], config);

  return { [dataType]: propertyMap };
}
